import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { Container } from "reactstrap";

import { connect } from "react-redux";
import {
  getSpecialties,
  setSearchQuery,
  setPage
} from "../../actions/specialtiesActions";

import SpecialtiesList from "./SpecialtiesList";
import PageTransition from "../styles/PageTransition";
import PanelNavs from "../PanelNavs";
import Loader from "../Loader";
import Paginator from "../Paginator";
import PageMeta from "../PageMeta";
import PanelHead from "../PanelHead";
import ContainerHeader from "../styles/ContainerHeader";
import LoaderWrapper from "../styles/LoaderWrapper";

class SpecialtiesContainer extends Component {
  searchField = createRef();

  handleSubmitData = async () => {
    await this.props.getSpecialties(this.props.filters);
  };

  componentDidMount() {
    this.handleSubmitData();
  }

  handleSearch = async query => {
    await this.props.setSearchQuery(query);
    this.handleSubmitData();
  };

  handleReload = async () => {
    this.searchField.current.state.query = "";
    await this.props.setSearchQuery("");
    this.handleSubmitData();
  };

  handlePaginator = async page => {
    await this.props.setPage(page);
    this.handleSubmitData();
  };

  render() {
    const {
      loading,
      specialties,
      first,
      last,
      next,
      prev,
      meta,
      filters
    } = this.props;

    return (
      <PageTransition>
        <Container>
          <fieldset disabled={loading} aria-busy={loading}>
            <ContainerHeader>
              <PanelNavs
                title="Especialidades Médicas"
                url="/specialties/add"
                add={true}
              />
              <PanelHead
                handleSearch={this.handleSearch}
                handleReload={this.handleReload}
                refe={this.searchField}
                loading={loading}
              />
              <PageMeta {...meta} currentPage={filters.page} />
            </ContainerHeader>

            {loading ? (
              <LoaderWrapper>
                <Loader noBg={true} />
              </LoaderWrapper>
            ) : (
              <SpecialtiesList specialties={specialties} />
            )}
            {specialties.length > 0 && !loading && (
              <Paginator
                currentPage={filters.page}
                first={first}
                last={last}
                next={next}
                prev={prev}
                handlePaginator={this.handlePaginator}
              />
            )}
          </fieldset>
        </Container>
      </PageTransition>
    );
  }
}

SpecialtiesContainer.propTypes = {
  specialties: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  filters: PropTypes.object.isRequired,
  first: PropTypes.string,
  last: PropTypes.string,
  next: PropTypes.string,
  prev: PropTypes.string,
  meta: PropTypes.object.isRequired,
  getSpecialties: PropTypes.func.isRequired,
  setSearchQuery: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  specialties: state.specialties.specialties,
  loading: state.specialties.loading,
  filters: state.specialties.filters,
  first: state.specialties.links.first,
  last: state.specialties.links.last,
  next: state.specialties.links.next,
  prev: state.specialties.links.prev,
  meta: state.specialties.meta
});

export default connect(mapStateToProps, {
  getSpecialties,
  setSearchQuery,
  setPage
})(SpecialtiesContainer);
